import RowButton from 'components/atoms/row-button'
import SelectTableFilter from 'components/atoms/select-table-filter'
import React from 'react'
import PropTypes from 'prop-types'
import TimeUtil from 'utils/time-util'
import ActiveStatusBadge from 'domains/cms-blog-post/atoms/active-status-badge'
import { ACTIVE_STATUS } from 'domains/cms-blog-post/constants'
import { WEB_URL_CONSTANTS } from 'constants/web-url-constants'

const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}

const propTypes = {
  buttonText       : PropTypes.string,
  buttonColour     : PropTypes.string,
  isButtonDisabled : PropTypes.func,
  onButtonClick    : PropTypes.func
}

/**
 * Columns definition for Cms Blog Post Table
 * @param {string} buttonText - The text that appears at the button on each row
 * @param {string} buttonColour - Bootstrap button type class name (eg. primary)
 * @param {Function} isButtonDisabled - function that will check whether the button on particular row is disabled
 * @param {Function} onButtonClick - function that will run when the button is clicked
 */
const cmsBlogPostTableColumns = ({
  buttonText,
  buttonColour,
  isButtonDisabled,
  onButtonClick
}) => {

  // Custom Cell
  // Used to modify the cell in specific columns
  const CategoryCell = (row) => (row.cell.value.join(', '))

  const DateCell = (row) => TimeUtil.format(row.cell.value)
  const UrlCell  = (row) => (
    <a
      className='text-primary'
      href={ `${WEB_URL_CONSTANTS.HOMEPAGE}/blog/${row.cell.value}` }
      target='_blank' rel='noopener noreferrer'
    >
      { `blog/${row.cell.value}` }
    </a>
  )

  const ActiveStatusCell = (row) => <ActiveStatusBadge active_status={ row.cell.value } />

  // eslint-disable-next-line react/prop-types
  const ActiveStatusFilter = ({ column }) => {
    const options = Object.keys(ACTIVE_STATUS).map((key) => (
      {
        label : ACTIVE_STATUS[key],
        value : ACTIVE_STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  // eslint-disable-next-line react/prop-types
  const ActionCell = ({ cell: { row } }) => {

    const disabled = isButtonDisabled ? isButtonDisabled(row.original) : false

    return (
      <RowButton
        data={ row.original }
        color={ buttonColour }
        onClick={ onButtonClick }
        disabled={ disabled }
        text={ buttonText }
      />
    )
  }
  ActionCell.propTypes = actionCellPropTypes


  return (
    [
      {
        Header         : 'Id',
        accessor       : 'id',
        disableFilters : false
      },
      {
        Header         : 'Title',
        accessor       : 'title',
        disableFilters : false
      },
      {
        Header   : 'Category',
        accessor : 'categories',
        id       : 'category',
        Cell     : CategoryCell
      },
      {
        Header   : 'Active Status',
        accessor : 'active_status',
        Filter   : ActiveStatusFilter,
        Cell     : ActiveStatusCell
      },
      {
        Header         : 'Url Key',
        accessor       : 'url',
        disableFilters : false,
        Cell           : UrlCell
      },
      {
        Header         : 'Posted Date',
        accessor       : 'posted_date',
        disableFilters : true,
        Cell           : DateCell
      },
      {
        Header : 'Action',
        id     : 'action',
        Cell   : ActionCell
      }
    ]
  )
}

cmsBlogPostTableColumns.propTypes = propTypes

export default cmsBlogPostTableColumns
